import {getColor} from "@/styles/ThemeConfig";
import {css} from "styled-components";
import Image from "next/image";
import {useEffect, useState} from "react";
import {DangerousDescriptionWrapper} from "@/styles/GlobalStyles";


export default function CountryTextImageSection({title,description, image})
{
    const [isClient, setIsClient] = useState(false);

    // Check if the component is rendering on the client
    useEffect(() => {
        setIsClient(true);
    }, []);


    return <div
        style={{
            backgroundColor: getColor('grayBackground')
        }}
    >
        <div style={{
            paddingLeft: 'calc(50vw - 695px)',
        }}>

            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            }}>
                <div style={{
                    padding: "2em",
                }}>
                    {title && (
                        <h2 className={'h1'} style={{
                            "fontFamily": "Josefin Sans",
                            fontWeight: 'bold',
                            "color": "#c49959",
                            "marginBottom": "15px",
                            "textTransform": "uppercase",
                            "fontSize": "2.1em",
                        }}>
                            {title}
                        </h2>
                    )}

                    {isClient && (
                        <DangerousDescriptionWrapper
                            customStyle={css`
                                        max-width: 800px;
                                        p {
                                            color: ${getColor('greenText')}!important;
                                        }
                                    `}
                            dangerouslySetInnerHTML={{__html: description}}
                        />
                    )}
                </div>

                <Image
                    className={'desktop_only'}
                    style={{
                        objectFit: 'cover',
                    }}
                    src={image?.url}
                    alt={image?.alt ?? image?.name} width={550} height={550}
                />
            </div>
        </div>
    </div>
}
